import styled from 'styled-components';

const NavContainer = styled.div`
  display: flex;
  justify-content: center;
`;

export default NavContainer;



// WEBPACK FOOTER //
// ./src/kentico-blocks/HorizontallyNavigableContent/NavContainer.jsx